import { Badge, BadgeProps, useTheme } from "@mui/material";

interface OcBadgeProps extends BadgeProps {
  badgeContent?: number;
}
export const OcBadge: React.FC<OcBadgeProps> = ({ ...props }) => {
  const theme = useTheme();
  return (
    <Badge
      max={99}
      {...props}
      sx={{
        ".MuiBadge-badge": {
          color: theme.palette.white.main,
          backgroundColor: theme.palette.primary.main,
          borderRadius: "2px",
          fontSize: "10px",
          minWidth: "16px",
          width:
            props.badgeContent && props.badgeContent > 99 ? "20px" : "16px",
          height: "16px",
          paddingTop: "2px",
          fontWeight: 500,
        },
        ...props.sx,
      }}
    />
  );
};
